import { jsx as e } from "react/jsx-runtime";
import { DropdownHeader as r, DropdownDivider as t, DropdownItem as m, Dropdown as n, Button as d } from "flowbite-react";
import { buttonTheme as i } from "../Button/theme.js";
import { theme as p } from "./theme.js";
const s = (o) => /* @__PURE__ */ e(
  n,
  {
    ...o,
    theme: p,
    renderTrigger: () => /* @__PURE__ */ e(
      d,
      {
        theme: i,
        color: "light",
        className: "mr-2 relative",
        size: "sm",
        children: o.label
      }
    )
  }
), c = Object.assign(s, {
  Item: m,
  Divider: t,
  Header: r
});
export {
  c as Dropdown,
  p as dropdownTheme
};
